import { BatteryChargingWirelessAlertIcon } from './BatteryChargingWirelessAlertIcon';

/**
 * author: Michael Richins
 * id F835E187-444F-43B8-A057-9915F1388A87
 * name battery-charging-wireless-alert
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-charging-wireless-alert.svg
 * tags
 * - Battery 
 * - Home Automation 
 * - Alert / Error 
 */
export const BatteryChargingWirelessWarningIcon = BatteryChargingWirelessAlertIcon;
export default BatteryChargingWirelessWarningIcon